/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';

import {Steps} from "../../constant/steps";
import {ActivatedRoute} from "@angular/router";

import {SessionService} from "../../services/session.service";

import {SignerService} from "../../services/signer.service";

import {interval, Subscription} from "rxjs";
import {HttpService} from "../../http/http.service";
import {SignerDto} from "../../model/signerDto";
import {RootScopeService} from "../../services/rootscope.service";
import {RedirectionService} from "../../services/redirection.service";
import {SessionDto} from "../../model/sessionDto";
import ExternalSessionStatusEnum = SessionDto.ExternalSessionStatusEnum;
import ExternalSignerStatusEnum = SignerDto.ExternalSignerStatusEnum;

@Component({
    selector: 'app-pending-signature',
    templateUrl: './pending-signature.component.html'
})
export class PendingSignatureComponent implements OnInit {


    private sessionId: string = '';
    private retry: Subscription;

    constructor(private route: ActivatedRoute, private rootScope: RootScopeService, private sessionService: SessionService, private signerService: SignerService, private redirectionService: RedirectionService, private httpService: HttpService) {
        this.retry = interval(this.rootScope.get().properties.signature.retry).subscribe(() => {
            this.startSign();
        });
    }

    ngOnInit(): void {
        this.rootScope.get().step = Steps.agreements;

        // Check the sessionId
        this.sessionId = this.route.snapshot.params['sessionId'];
        //single redirectionFactory
        //   redirectionFactory.get();

        if (this.sessionId !== this.sessionService.id) {
            console.warn('The session ID in the url is not the same as the saved : url->' + this.sessionId + ' | saved->' + this.sessionService.id);
            this.redirectionService.session(this.route, this.sessionId);
            return;
        }

        // Check the status of the session
        if (!this.sessionService.info || this.sessionService.info.externalSessionStatus !== ExternalSessionStatusEnum.Init) {
            console.warn('The current signer is undefined or is not at the init status');
            this.redirectionService.session(this.route, this.sessionId);
            return;
        }

        // Check the status of the signer
        if (!this.signerService.currentSigner || this.signerService.currentSigner.externalSignerStatus !== ExternalSignerStatusEnum.PendingSignature) {
            console.warn('The current signer is undefined or is not at the pending signature status');
            this.redirectionService.session(this.route, this.sessionId);
            return;
        }

        this.startSign();

    }

    startSign(): void {
        let that = this;

        this.httpService.initAgreements(this.sessionService.id, this.signerService.currentSigner.extSignerId).toPromise().then(function (response) {
            if (response && response.success) {
                if (response.result) {
                    let signerDto: SignerDto = response.result as SignerDto;
                    if (signerDto.externalSignerStatus === ExternalSignerStatusEnum.Agreements) {

                        that.retry.unsubscribe();
                        that.redirectionService.session(that.route, that.sessionId);
                    }
                }
            }
        });
    }


}
